var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-shadow */
import { useEffect, useState, createContext, useContext } from 'react';
const Context = createContext({});
export const usePortals = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('usePortals must be used within PortalWatcher');
    }
    return context;
};
export const PortalWatcher = (props) => {
    const [portals, setPortals] = useState({});
    useEffect(() => {
        const elements = document.querySelectorAll('[data-portal-id]');
        const newPortals = {};
        elements.forEach((node) => {
            const id = node.getAttribute('data-portal-id');
            if (!id) {
                return;
            }
            newPortals[id] = node;
        });
        setPortals(newPortals);
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== node.ELEMENT_NODE) {
                        return;
                    }
                    // annoyingly, MutationObserver only returns the top level node so we need to walk through it
                    const walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT, {
                        acceptNode: (node) => {
                            return node.hasAttribute('data-portal-id')
                                ? NodeFilter.FILTER_ACCEPT
                                : NodeFilter.FILTER_SKIP;
                        }
                    });
                    do {
                        const portalId = walker.currentNode.getAttribute('data-portal-id');
                        if (portalId) {
                            setPortals((portals) => (Object.assign(Object.assign({}, portals), { [portalId]: walker.currentNode })));
                        }
                    } while (walker.nextNode());
                });
                mutation.removedNodes.forEach((node) => {
                    if (node.nodeType !== node.ELEMENT_NODE) {
                        return;
                    }
                    const portalId = node.getAttribute('data-portal-id');
                    if (portalId) {
                        setPortals((portals) => {
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            const _a = portals, _b = portalId, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                            return rest;
                        });
                    }
                });
            }
        });
        observer.observe(document, {
            subtree: true,
            childList: true
        });
        return () => {
            observer.disconnect();
        };
    }, []);
    return _jsx(Context.Provider, { value: portals, children: props.children });
};
